<a *ngIf="!isMobile" href="javascript:void(0)">
  <mat-chip-list>
    <mat-chip class="toolbar-currency" [ngClass]="{'pr-0': !currencySymbol?.match('INR|USD|GBP|EUR')}" [matMenuTriggerFor]="currencyMenu" >
      <div class="currency-symbol" [innerHTML]="currencySymbol"></div>
      <mat-icon>arrow_drop_down</mat-icon>
    </mat-chip>
  </mat-chip-list>
</a>
<mat-menu #currencyMenu="matMenu" class="menu">
  <div *ngFor="let item of supportedCurrencies" [ngClass]="{'act': currency===item?.currency}">
    <button class="menu-item" mat-menu-item (click)="setCurrencyFromMenu(item)" [disabled]="variablesService?.thirdPartyApp">
      <span class="default-font" [innerHTML]="isMobile ? item?.currency : item?.symbol"></span>
    </button>
  </div>
</mat-menu>

<mat-chip-list *ngIf="isMobile">
  <mat-chip class="currency-chip" [matMenuTriggerFor]="currencyMenu" >
    <div class="default-font" [innerHTML]="currency"></div>
    <mat-icon>arrow_drop_down</mat-icon>
  </mat-chip>
  <!-- <mat-chip class="currency-chip">
    <select class="currency-select" (change)="setCurrencyFromMenu($event, 'select')" [disabled]="variablesService?.thirdPartyApp">
      <option *ngFor="let item of supportedCurrencies" [value]="item.symbol" [selected]="currencySymbol==item.symbol">
        <span class="default-font" [innerHTML]="item.currency"></span>
      </option>
    </select>
    <mat-icon class="icon">arrow_drop_down</mat-icon>
  </mat-chip> -->
</mat-chip-list>